import orbitMessages from './orbit-messages'
import legalMessages from './legal-messages'
import uiMessages from './ui-messages'
import operationMessages from './operation-messages'
import tutorialMessages from './tutorial-messages'
import helpMessages from './help-messages'
import workflowMessages from './workflow-messages'
import apiMessages from './api-messages'
import completionMessages from './completion-messages'

export default {
  'zh-HK': orbitMessages['zh-HK'],
  en: {
    ...orbitMessages.en,
    ...legalMessages.en,
    ...uiMessages.en,
    ...operationMessages.en,
    ...tutorialMessages.en,
    ...helpMessages.en,
    ...workflowMessages.en,
    ...apiMessages.en,
    ...completionMessages.en,
    '全部标记为已读': 'Mark all as read',
    '选择语言': 'Select language',
    '服务条款与隐私': 'Terms & Privacy',
    '关闭弹框': 'Close dialog',
    '打开导航菜单': 'Open navigation menu',
    '导航菜单': 'Navigation menu',
    '台': 'bots',
    '单': 'orders',
    '全网累计收益率': 'Network-wide cumulative return',
    '已有账户': 'Already have an account',
    '遇到问题？ 联系在线客服': 'Need help? Contact support',
    '实时更新': 'Real-time',
    'PRIME · 旗舰': 'PRIME · Flagship',
    '★ PRIME · 旗舰': '★ PRIME · Flagship',
    '中等': 'Medium',
    '© 2026 UPlus Technologies. 保留所有權利。': '© 2026 UPlus Technologies. All rights reserved.',
    '免费注册': 'Sign up free',
    '注册领点卡': 'Sign up for points',
    '公开数据已同步': 'Public data synced',
    '正在同步公开数据': 'Syncing public data',
    '公开数据暂时不可用': 'Public data is temporarily unavailable',
    '让专业策略，替你交易': 'Let professional strategies trade for you',
    'AI 多策略自动交易，一个账户管理全部交易所、机器人与资金流向，收益与费用透明可查。': 'Automate multiple AI strategies and manage exchanges, bots, funds, earnings, and fees in one account.',
    '立即免费注册': 'Sign up free',
    '登录查看我的资产': 'Log in to view my assets',
    '银行级加密存储': 'Bank-grade encrypted storage',
    '资金不托管': 'Non-custodial funds',
    'API 交易授权': 'API trading authorization',
    '公开数据实时同步': 'Real-time public data sync',
    '平台累计结算收益 (USDT)': 'Platform settled earnings (USDT)',
    '平台累计收益率': 'Platform cumulative return',
    '运行中机器人': 'Active bots',
    '稳定运行天数': 'Stable operating days',
    '实时成交': 'Live trades',
    '正在加载公开成交数据…': 'Loading public trades…',
    '暂无公开成交数据': 'No public trades',
    '策略产品收益榜': 'Strategy product ranking',
    '登录后查看你的策略收益': 'Log in to view your strategy earnings',
    '注册后创建策略 →': 'Create a strategy after signing up →',
    '中高': 'Medium-high',
    '风险控制': 'Risk control',
    '强调风险控制的合约策略。': 'A contract strategy focused on risk control.',
    '合约 AI 交易': 'AI contract trading',
    '多空对冲': 'Long-short hedge',
    '以多空对冲方式执行合约交易。': 'Execute contract trades with long-short hedging.',
    'AI 合约策略': 'AI contract strategy',
    '适合主流币种与趋势行情的 AI 合约交易。': 'AI contract trading for major coins and trending markets.',
    'AI 智能选择指标并自动运行。': 'AI selects indicators and runs automatically.',
    '登录后查看收益曲线': 'Log in to view the earnings chart',
    '近 30 日收益率': '30-day return',
    '投入': 'Invested',
    '在运行': 'Running',
    '跟随资金': 'Capital following',
    '注册后启动': 'Start after signing up',
    '我的资产总览': 'My asset overview',
    '总资产 (USDT)': 'Total assets (USDT)',
    '今日收益 (USDT)': 'Today earnings (USDT)',
    '累计收益 (USDT)': 'Cumulative earnings (USDT)',
    '登录后查看你的专属收益曲线': 'Log in to view your earnings chart',
    '登录查看': 'Log in to view',
    '本周收益榜': 'Weekly earnings ranking',
    '实时榜单': 'Live ranking',
    '正在加载公开榜单…': 'Loading public ranking…',
    '暂无公开榜单数据': 'No public ranking data',
    '注册后上榜 →': 'Join the ranking after signing up →',
    '资产保留在用户自己的交易所账户，通过授权执行策略。': 'Assets remain in your exchange account while authorized strategies execute trades.',
    '数据实时更新': 'Real-time updates',
    '账户、策略和收益数据实时更新，状态清晰可见。': 'Account, strategy, and earnings data update in real time with clear status.',
    '费用记录可查': 'Traceable fee records',
    '登录后可查询资产与点卡的实际流水。': 'Log in to review asset and point transaction records.',
    '风险提示：数字资产交易存在较高市场风险，策略历史表现不代表未来收益。请在充分了解产品规则与风险的前提下，根据自身风险承受能力谨慎决策。本页面数据为演示环境模拟数据。': 'Risk notice: Digital asset trading involves substantial market risk. Past strategy performance does not guarantee future returns. Make prudent decisions based on your risk tolerance after understanding the rules and risks. Data on this page is simulated for demonstration.',
    'UPlus 账户入口': 'UPlus account access',
    '让专业策略，': 'Let professional strategies',
    '替你交易。': 'trade for you.',
    '一个账户管理全部交易所、机器人与资金流向，收益与费用透明可查。': 'Manage all exchanges, bots, and fund flows in one account with transparent earnings and fees.',
    'AI 多策略自动交易，7×24 小时运行': 'Automated multi-strategy AI trading, 24/7',
    '资金 / 燃料 / 点卡账户集中管理': 'Centralized fund, fuel, and point accounts',
    '实时风控扫描与保证金健康度监控': 'Real-time risk scans and margin health monitoring',
    'API 只读交易授权': 'Read-only and trading API authorization',
    '欢迎回来': 'Welcome back',
    '登录你的 UPlus 账户，继续自动交易': 'Log in to your UPlus account to continue automated trading',
    '邮箱 / 手机号': 'Email / mobile number',
    '请输入邮箱或手机号': 'Enter your email or mobile number',
    '请输入密码': 'Enter your password',
    '忘记密码？': 'Forgot password?',
    '登录即代表你同意': 'By logging in, you agree to',
    '《服务协议》': 'Terms of Service',
    '《隐私政策》': 'Privacy Policy',
    '创建账户': 'Create account',
    '三分钟完成注册，开启自动交易': 'Create your account in three minutes and start automated trading',
    '邮箱': 'Email',
    '请输入邮箱': 'Enter your email',
    '验证码': 'Verification code',
    '6 位验证码': '6-digit code',
    '获取验证码': 'Get code',
    '设置密码': 'Set password',
    '至少 8 位，含大小写字母、数字和符号': 'At least 8 characters with upper/lowercase letters, numbers, and symbols',
    '邀请码（选填）': 'Invitation code (optional)',
    '如有邀请码请填写': 'Enter an invitation code if available',
    '我已阅读并同意': 'I have read and agree to',
    '重置密码': 'Reset password',
    '输入注册邮箱，我们将发送验证码用于身份验证': 'Enter your registered email and we will send a verification code',
    '验证码已发送，请填写验证码并设置新密码': 'The code has been sent. Enter it and set a new password',
    '验证邮箱': 'Verify email',
    '设置新密码': 'Set new password',
    '注册邮箱': 'Registered email',
    '请输入注册时使用的邮箱': 'Enter your registered email',
    '我们会向该邮箱发送一封含 6 位验证码的邮件，请注意查收垃圾邮件箱。': 'We will email a 6-digit code. Please also check your spam folder.',
    '发送验证码': 'Send code',
    '重新发送': 'Resend',
    '新密码': 'New password',
    '确认新密码': 'Confirm new password',
    '请再次输入新密码': 'Enter the new password again',
    '完成重置': 'Complete reset',
    '重置中…': 'Resetting…',
    '密码重置成功，请使用新密码登录': 'Password reset. Log in with your new password',
    '密码重置失败': 'Password reset failed',
    '邮箱格式不正确，请检查后重试': 'Invalid email format. Check and try again',
    '收益趋势': 'Earnings trend',
    '账户累计收益趋势': 'Account cumulative earnings trend',
    '选择收益年份': 'Select earnings year',
    '选择收益月份': 'Select earnings month',
    '数据同步中': 'Syncing data',
    '数据已同步': 'Data synced',
    '尚未同步': 'Not synced',
    '部分数据暂不可用': 'Some data is temporarily unavailable',
    '运行中策略': 'Active strategies',
    '策略名称': 'Strategy name',
    '交易对': 'Trading pair',
    '交易所': 'Exchange',
    '保证金健康度': 'Margin health',
    '风险': 'Risk',
    '操作': 'Actions',
    '前往机器人页 ›': 'Go to bots ›',
    '机器人健康与风险': 'Bot health and risk',
    '查看策略 ›': 'View strategies ›',
    '运行良好': 'Healthy',
    '需要关注': 'Needs attention',
    '高风险': 'High risk',
    '机器人健康评分': 'Bot health score',
    '查看收益明细': 'View earnings details',
    '查看完整榜单 ›': 'View full ranking ›',
    '账户划转': 'Account transfer',
    '用于抵扣机器人策略服务费': 'Used to offset bot strategy service fees',
    '消费记录': 'Usage records',
    '常见问题、费用与分成说明、风控规则与安全指南。': 'FAQs, fees and profit sharing, risk controls, and security guides.',
    '打开帮助中心': 'Open Help Center',
    '三步完成首个机器人配置：充值 → 划转燃料 → 选择策略模板。': 'Set up your first bot in three steps: deposit → transfer fuel → select a strategy template.',
    '查看教程': 'View tutorial',
    '我的机器人': 'My bots',
    '创建、监控与管理全部自动交易策略': 'Create, monitor, and manage all automated trading strategies',
    '启动新机器人': 'Start a new bot',
    '导出历史记录': 'Export history',
    '系统在线': 'System online',
    '产品与策略': 'Products and strategies',
    '策略市场': 'Strategy marketplace',
    '展开全部': 'Expand all',
    '收起': 'Collapse',
    '高频出手、快进快出': 'High-frequency, fast entry and exit',
    '顺势单向持仓、回撤可控': 'Trend-following one-way positions with controlled drawdown',
    '立即创建': 'Create now',
    '近 30 日': 'Last 30 days',
    '今日执行': 'Today executions',
    '平均保证金健康度': 'Average margin health',
    '未绑定 API': 'API not bound',
    '交易所加载中': 'Loading exchanges',
    '还没有运行中的策略': 'No active strategies yet',
    '从上方「产品与策略」选择一个模板，三步即可启动你的第一台机器人；': 'Select a template above to start your first bot in three steps.',
    '风险保护与保证金监控将自动开启。': 'Risk protection and margin monitoring will start automatically.',
    '机器人运行中': 'Bot running',
    '机器人已关闭': 'Bot stopped',
    '机器人已删除': 'Bot deleted',
    '当前状态不可操作': 'This status cannot be operated',
    '收益来源、风险水平与策略表现分析': 'Analyze earnings sources, risk levels, and strategy performance',
    '导出收益报表': 'Export earnings report',
    '本月收益 (USDT)': 'Monthly earnings (USDT)',
    '本月收益率': 'Monthly return',
    '累计收益率': 'Cumulative return',
    '收益构成': 'Earnings composition',
    '最大回撤': 'Maximum drawdown',
    '最近结算': 'Recent settlements',
    '正在加载收益数据…': 'Loading earnings data…',
    '暂无收益构成数据': 'No earnings composition data',
    '暂无最近结算数据': 'No recent settlement data',
    '黄金三角交易': 'Triangular trading',
    '币币双向AI交易': 'Spot auto trading',
    'UB交易': 'UB trading',
    '现货网格': 'Spot grid',
    '现货马丁': 'Spot martingale',
    '智能合约交易': 'Smart contract trading',
    '收益来源': 'Earnings source',
    '成交单数': 'Filled orders',
    '收益金额 (USDT)': 'Earnings amount (USDT)',
    '收益率': 'Return',
    '胜率': 'Win rate',
    '收益占比': 'Earnings share',
    '按策略': 'By strategy',
    '按交易所': 'By exchange',
    '收益日历': 'Earnings calendar',
    '暂无收益趋势数据': 'No earnings trend data',
    '暂无榜单数据': 'No ranking data',
    '正在加载收益趋势…': 'Loading earnings trend…',
    '正在加载榜单…': 'Loading ranking…',
    '查看完整榜单': 'View full ranking',
    '资产': 'Assets',
    '资金、燃料与点卡账户集中管理': 'Centralized management of fund, fuel, and point accounts',
    '资金与点卡账户集中管理': 'Centralized management of fund and point accounts',
    '刷新资产': 'Refresh assets',
    '充值': 'Deposit',
    '燃料账户、资金账户和点卡账户资产分布': 'Asset allocation across fuel, fund, and point accounts',
    '资金账户和点卡账户资产分布': 'Asset allocation across fund and point accounts',
    '资金账户': 'Fund account',
    '燃料账户': 'Fuel account',
    '点卡账户': 'Point account',
    '用于充值、提现与内部划转。': 'Used for deposits, withdrawals, and internal transfers.',
    '用于机器人运行与平台服务结算。': 'Used for bot operation and platform service settlement.',
    '用于抵扣平台服务费，消费时优先扣除。': 'Used to offset platform service fees and deducted first.',
    '充值提现订单': 'Deposit and withdrawal orders',
    '资金流水': 'Fund records',
    '充值订单': 'Deposit orders',
    '提现订单': 'Withdrawal orders',
    '全部状态': 'All statuses',
    '渠道 · 地址': 'Network · Address',
    '审核中': 'Under review',
    '暂无订单数据': 'No order data',
    '正在同步订单…': 'Syncing orders…',
    '充值与提现订单与账单页资金流水保持一致，可交叉核对。': 'Deposit and withdrawal orders match the billing fund records for cross-checking.',
    '账单明细': 'Billing details',
    '每一笔收益、扣费与账户变化，透明可查': 'Every earning, fee, and account change is transparent and traceable',
    '导出当月账单': 'Export monthly bill',
    '本月服务费 (USDT)': 'Monthly service fee (USDT)',
    '本月结算收益 (USDT)': 'Monthly settled earnings (USDT)',
    '可用点卡': 'Available points',
    '按当前消耗预计可用 --': 'Estimated remaining use: --',
    '逐笔可查': 'Itemized and traceable',
    '燃料 / 点卡记录': 'Fuel / point records',
    '充值 / 提现记录': 'Deposit / withdrawal records',
    '购买点卡 / 资金划转记录': 'Point purchase / fund transfer records',
    '燃料 / 点卡': 'Fuel / points',
    '充值 / 提现': 'Deposit / withdrawal',
    '购买点卡/资金划转': 'Point purchase / fund transfer',
    '类别查询': 'Category',
    '购买点卡与燃料划转记录类型': 'Point purchase and fuel transfer record type',
    '购买点卡记录': 'Point purchase records',
    '燃料划转记录': 'Fuel transfer records',
    '燃料划转': 'Fuel transfer',
    '记录类型': 'Record type',
    '支付金额 (USDT)': 'Payment amount (USDT)',
    '资金账户 / 燃料账户': 'Funding account / Fuel account',
    '资金账户 → 燃料账户': 'Funding account → Fuel account',
    '燃料账户 → 资金账户': 'Fuel account → Funding account',
    '搜索策略名称…': 'Search strategy name…',
    '全部类型': 'All types',
    '全部交易': 'All trades',
    '账单类型': 'Billing type',
    '收益 (USDT)': 'Earnings (USDT)',
    '余额 (USDT)': 'Balance (USDT)',
    '正在同步账单记录…': 'Syncing billing records…',
    '暂无符合条件的账单记录': 'No matching billing records',
    '充值提现记录类型': 'Deposit/withdrawal record type',
    '订单类型': 'Order type',
    '交易类型': 'Trade type',
    '利润分成': 'Profit sharing',
    '点卡抵扣': 'Point deduction',
    '返回通知中心': 'Back to notifications',
    '通知详情': 'Notification details',
    '正在读取通知详情…': 'Loading notification details…',
    '重新加载': 'Reload',
    '处理中…': 'Processing…',
    '点击查看通知详情': 'Click to view notification details',
    '左右滑动查看': 'Swipe sideways to view',
    '暂无收益数据': 'No earnings data',
    '平均健康度': 'Average health',
    '币币策略最小仓位读取失败': 'Failed to load the minimum spot-strategy position',
    '未找到当前币币策略的交易对配置': 'No trading-pair configuration was found for this spot strategy',
    '机器人页面尚未加载当前交易所状态': 'The current exchange status has not loaded on the Bots page',
    '请输入有效的杠杆倍数': 'Enter a valid leverage',
    '我已了解暂停策略可能影响当前挂单与持仓': 'I understand that pausing may affect existing orders and positions',
    '请先确认已了解暂停策略的风险': 'Confirm that you understand the risks of pausing this strategy',
    'FITFI 投入金额不能超过 2000 USDT': 'FITFI investment cannot exceed 2,000 USDT',
    '只授权交易，不授权提币': 'Trading permission only; withdrawals disabled',
    '绑定时请勿开启提币权限；建议同时配置 IP 白名单以提升安全性。': 'Do not enable withdrawal permission. Configure an IP allowlist for better security.',
    '登录保护': 'Login protection',
    '台运行中': 'running',
    '条策略': 'strategies',
    'AI智能化策略': 'AI-powered strategies',
    '100 USDT 开启，AI 智能选指标并自动运行': 'Start with 100 USDT; AI selects indicators and runs automatically',
    '比普通版收益高，覆盖范围适中': 'Higher returns than the standard version with moderate coverage',
    '收益最高的版本，下跌覆盖 30% 左右，适合主流币': 'Highest-return version with about 30% downside coverage for major coins',
    '请先删除当前仓位后再修改策略': 'Delete the current position before editing this strategy',
    '内部转账失败': 'Internal transfer failed',
    '，请手动启动机器人': '; start the bot manually',
    '修改后的投入金额低于当前投入金额，确认继续修改吗？': 'The new investment is lower than the current amount. Continue?',
    'AI 网格': 'AI grid',
    '首推': 'Featured',
    '全自动 AI 交易，适合所有行情': 'Fully automated AI trading for all market conditions',
    '启动 UPlus-S1': 'Start UPlus-S1',
    '请输入投入金额': 'Enter the investment amount',
    '可用余额': 'Available balance',
    '最低 1,000 USDT，最高 20,000 USDT': 'Minimum 1,000 USDT; maximum 20,000 USDT',
    '固定杠杆': 'Fixed leverage',
    '固定使用 10x 杠杆': 'Uses fixed 10x leverage',
    '策略参数由 Orbit 自动管理，创建后将根据行情独立运行。': 'Orbit manages the strategy parameters and runs independently according to market conditions after creation.',
    '确认启动': 'Confirm start',
    '可用余额读取失败': 'Failed to load available balance',
    '请输入有效的投入金额': 'Enter a valid investment amount',
    'Orbit 策略投入金额不能低于 1,000 USDT': 'Orbit investment cannot be less than 1,000 USDT',
    'Orbit 策略投入金额不能超过 20,000 USDT': 'Orbit investment cannot exceed 20,000 USDT',
    '请先成功读取交易所可用余额': 'Load the exchange available balance first',
    'UPlus-S1合约交易风险提示': 'UPlus-S1 contract trading risk notice',
    'Orbit 策略创建失败': 'Failed to create the Orbit strategy',
    'Orbit 策略创建失败，请稍后重试': 'Failed to create the Orbit strategy. Try again later',
    'UPlus-S1 创建成功': 'UPlus-S1 created successfully',
    '确认减少投入金额': 'Confirm investment reduction'
  },
  ko: {
    ...orbitMessages.ko,
    ...legalMessages.ko,
    ...uiMessages.ko,
    ...operationMessages.ko,
    ...tutorialMessages.ko,
    ...helpMessages.ko,
    ...workflowMessages.ko,
    ...apiMessages.ko,
    ...completionMessages.ko,
    '全部标记为已读': '모두 읽음으로 표시',
    '选择语言': '언어 선택',
    '服务条款与隐私': '서비스 약관 및 개인정보 처리방침',
    '关闭弹框': '대화 상자 닫기',
    '打开导航菜单': '탐색 메뉴 열기',
    '导航菜单': '탐색 메뉴',
    '台': '대',
    '单': '건',
    '全网累计收益率': '전체 네트워크 누적 수익률',
    '已有账户': '이미 계정이 있으신가요?',
    '遇到问题？ 联系在线客服': '도움이 필요하신가요? 고객센터에 문의하세요',
    '让专业策略，': '전문 전략이',
    '替你交易。': '대신 거래합니다.',
    '一个账户管理全部交易所、机器人与资金流向，收益与费用透明可查。': '하나의 계정에서 모든 거래소, 봇, 자금 흐름을 관리하고 수익과 비용을 투명하게 확인하세요.',
    'AI 多策略自动交易，7×24 小时运行': 'AI 다중 전략 자동 거래, 24시간 운영',
    '资金 / 燃料 / 点卡账户集中管理': '자금 / 연료 / 포인트 계정 통합 관리',
    '实时风控扫描与保证金健康度监控': '실시간 위험 관리 스캔 및 증거금 건전성 모니터링',
    'API 只读交易授权': 'API 읽기 및 거래 권한',
    '实时更新': '실시간 업데이트',
    'PRIME · 旗舰': 'PRIME · 플래그십',
    '★ PRIME · 旗舰': '★ PRIME · 플래그십',
    '中等': '중간',
    '© 2026 UPlus Technologies. 保留所有權利。': '© 2026 UPlus Technologies. 모든 권리 보유.',
    '风险提示：数字资产交易存在较高市场风险，策略历史表现不代表未来收益。请在充分了解产品规则与风险的前提下，根据自身风险承受能力谨慎决策。本页面数据为演示环境模拟数据。': '위험 고지: 디지털 자산 거래에는 높은 시장 위험이 있으며 과거 전략 성과가 미래 수익을 보장하지 않습니다. 상품 규칙과 위험을 충분히 이해한 뒤 본인의 위험 감수 능력에 따라 신중하게 결정하세요. 이 페이지의 데이터는 데모 환경의 모의 데이터입니다.',
    '免费注册': '무료 회원가입',
    '注册领点卡': '가입하고 포인트 받기',
    '公开数据已同步': '공개 데이터 동기화 완료',
    '正在同步公开数据': '공개 데이터 동기화 중',
    '公开数据暂时不可用': '공개 데이터를 일시적으로 사용할 수 없습니다',
    '让专业策略，替你交易': '전문 전략이 대신 거래합니다',
    'AI 多策略自动交易，一个账户管理全部交易所、机器人与资金流向，收益与费用透明可查。': '하나의 계정에서 AI 다중 전략, 거래소, 봇, 자금 흐름, 수익과 수수료를 투명하게 관리하세요.',
    '立即免费注册': '지금 무료 가입',
    '登录查看我的资产': '로그인하여 내 자산 보기',
    '银行级加密存储': '은행급 암호화 저장',
    '资金不托管': '비수탁형 자금 관리',
    'API 交易授权': 'API 거래 권한',
    '公开数据实时同步': '공개 데이터 실시간 동기화',
    '平台累计结算收益 (USDT)': '플랫폼 누적 정산 수익 (USDT)',
    '平台累计收益率': '플랫폼 누적 수익률',
    '运行中机器人': '실행 중인 봇',
    '稳定运行天数': '안정 운영 일수',
    '实时成交': '실시간 체결',
    '正在加载公开成交数据…': '공개 체결 데이터 로딩 중…',
    '暂无公开成交数据': '공개 체결 데이터 없음',
    '策略产品收益榜': '전략 상품 수익 순위',
    '登录后查看你的策略收益': '로그인하여 전략 수익을 확인하세요',
    '注册后创建策略 →': '가입 후 전략 만들기 →',
    '中高': '중상',
    '风险控制': '위험 관리',
    '强调风险控制的合约策略。': '위험 관리에 중점을 둔 계약 전략입니다.',
    '合约 AI 交易': 'AI 계약 거래',
    '多空对冲': '롱숏 헤지',
    '以多空对冲方式执行合约交易。': '롱숏 헤지 방식으로 계약 거래를 실행합니다.',
    'AI 合约策略': 'AI 계약 전략',
    '适合主流币种与趋势行情的 AI 合约交易。': '주요 코인과 추세장에 적합한 AI 계약 거래입니다.',
    'AI 智能选择指标并自动运行。': 'AI가 지표를 선택하고 자동 실행합니다.',
    '登录后查看收益曲线': '로그인하여 수익 차트 보기',
    '近 30 日收益率': '최근 30일 수익률',
    '投入': '투입',
    '在运行': '실행 중',
    '跟随资金': '추종 자금',
    '注册后启动': '가입 후 시작',
    '我的资产总览': '내 자산 개요',
    '总资产 (USDT)': '총자산 (USDT)',
    '今日收益 (USDT)': '오늘 수익 (USDT)',
    '累计收益 (USDT)': '누적 수익 (USDT)',
    '登录后查看你的专属收益曲线': '로그인하여 내 수익 차트 보기',
    '登录查看': '로그인하여 보기',
    '本周收益榜': '주간 수익 순위',
    '实时榜单': '실시간 순위',
    '正在加载公开榜单…': '공개 순위 로딩 중…',
    '暂无公开榜单数据': '공개 순위 데이터 없음',
    '注册后上榜 →': '가입 후 순위 참여 →',
    '资产保留在用户自己的交易所账户，通过授权执行策略。': '자산은 사용자의 거래소 계정에 보관되며 승인된 전략만 실행됩니다.',
    '数据实时更新': '실시간 데이터 업데이트',
    '账户、策略和收益数据实时更新，状态清晰可见。': '계정, 전략, 수익 데이터가 실시간으로 갱신되어 상태를 명확히 확인할 수 있습니다.',
    '费用记录可查': '수수료 기록 조회 가능',
    '登录后可查询资产与点卡的实际流水。': '로그인하여 자산 및 포인트 거래 내역을 확인하세요.',
    'UPlus 账户入口': 'UPlus 계정',
    '欢迎回来': '다시 오신 것을 환영합니다',
    '登录你的 UPlus 账户，继续自动交易': 'UPlus 계정에 로그인하여 자동 거래를 계속하세요',
    '邮箱 / 手机号': '이메일 / 휴대폰 번호',
    '请输入邮箱或手机号': '이메일 또는 휴대폰 번호를 입력하세요',
    '请输入密码': '비밀번호를 입력하세요',
    '忘记密码？': '비밀번호를 잊으셨나요?',
    '登录即代表你同意': '로그인하면 다음에 동의하는 것으로 간주됩니다',
    '《服务协议》': '서비스 약관',
    '《隐私政策》': '개인정보 처리방침',
    '创建账户': '계정 만들기',
    '三分钟完成注册，开启自动交易': '3분 안에 가입하고 자동 거래를 시작하세요',
    '邮箱': '이메일',
    '请输入邮箱': '이메일을 입력하세요',
    '验证码': '인증 코드',
    '6 位验证码': '6자리 인증 코드',
    '获取验证码': '인증 코드 받기',
    '设置密码': '비밀번호 설정',
    '至少 8 位，含大小写字母、数字和符号': '대문자, 소문자, 숫자, 기호를 포함한 8자 이상',
    '邀请码（选填）': '초대 코드 (선택)',
    '如有邀请码请填写': '초대 코드가 있으면 입력하세요',
    '我已阅读并同意': '다음을 읽고 동의합니다',
    '重置密码': '비밀번호 재설정',
    '输入注册邮箱，我们将发送验证码用于身份验证': '가입 이메일을 입력하면 인증 코드를 보내드립니다',
    '验证码已发送，请填写验证码并设置新密码': '인증 코드가 전송되었습니다. 코드를 입력하고 새 비밀번호를 설정하세요',
    '验证邮箱': '이메일 인증',
    '设置新密码': '새 비밀번호 설정',
    '注册邮箱': '가입 이메일',
    '请输入注册时使用的邮箱': '가입 시 사용한 이메일을 입력하세요',
    '发送验证码': '인증 코드 보내기',
    '重新发送': '다시 보내기',
    '新密码': '새 비밀번호',
    '确认新密码': '새 비밀번호 확인',
    '请再次输入新密码': '새 비밀번호를 다시 입력하세요',
    '完成重置': '재설정 완료',
    '重置中…': '재설정 중…',
    '密码重置成功，请使用新密码登录': '비밀번호가 재설정되었습니다. 새 비밀번호로 로그인하세요',
    '密码重置失败': '비밀번호 재설정 실패',
    '收益趋势': '수익 추세',
    '账户累计收益趋势': '계정 누적 수익 추세',
    '数据同步中': '데이터 동기화 중',
    '数据已同步': '데이터 동기화 완료',
    '运行中策略': '실행 중인 전략',
    '策略名称': '전략 이름',
    '交易对': '거래 페어',
    '交易所': '거래소',
    '保证金健康度': '증거금 건전성',
    '风险': '위험',
    '操作': '작업',
    '机器人健康与风险': '봇 건전성 및 위험',
    '运行良好': '정상 운영',
    '需要关注': '주의 필요',
    '高风险': '고위험',
    '机器人健康评分': '봇 건전성 점수',
    '账户划转': '계정 이체',
    '打开帮助中心': '도움말 센터 열기',
    '查看教程': '튜토리얼 보기',
    '我的机器人': '내 봇',
    '创建、监控与管理全部自动交易策略': '모든 자동 거래 전략을 생성, 모니터링 및 관리합니다',
    '启动新机器人': '새 봇 시작',
    '导出历史记录': '내역 내보내기',
    '系统在线': '시스템 온라인',
    '产品与策略': '상품 및 전략',
    '策略市场': '전략 마켓',
    '展开全部': '모두 펼치기',
    '收起': '접기',
    '立即创建': '지금 만들기',
    '近 30 日': '최근 30일',
    '今日执行': '오늘 실행',
    '平均保证金健康度': '평균 증거금 건전성',
    '未绑定 API': 'API 미연결',
    '还没有运行中的策略': '실행 중인 전략이 없습니다',
    '机器人运行中': '봇 실행 중',
    '机器人已关闭': '봇 중지됨',
    '机器人已删除': '봇 삭제됨',
    '收益来源、风险水平与策略表现分析': '수익원, 위험 수준 및 전략 성과 분석',
    '导出收益报表': '수익 보고서 내보내기',
    '本月收益 (USDT)': '이번 달 수익 (USDT)',
    '本月收益率': '이번 달 수익률',
    '累计收益率': '누적 수익률',
    '收益构成': '수익 구성',
    '最大回撤': '최대 낙폭',
    '最近结算': '최근 정산',
    '正在加载收益数据…': '수익 데이터 불러오는 중…',
    '暂无收益构成数据': '수익 구성 데이터가 없습니다',
    '暂无最近结算数据': '최근 정산 내역이 없습니다',
    '黄金三角交易': '골든 트라이앵글 트레이딩',
    '币币双向AI交易': '현물 자동 거래',
    'UB交易': 'UB 거래',
    '现货网格': '현물 그리드',
    '现货马丁': '현물 마틴',
    '智能合约交易': '스마트 계약 거래',
    '收益来源': '수익원',
    '成交单数': '체결 건수',
    '收益金额 (USDT)': '수익 금액 (USDT)',
    '收益率': '수익률',
    '胜率': '승률',
    '收益占比': '수익 비중',
    '按策略': '전략별',
    '按交易所': '거래소별',
    '收益日历': '수익 캘린더',
    '暂无收益趋势数据': '수익 추세 데이터 없음',
    '暂无榜单数据': '순위 데이터 없음',
    '查看完整榜单': '전체 순위 보기',
    '资产': '자산',
    '资金、燃料与点卡账户集中管理': '자금, 연료 및 포인트 계정 통합 관리',
    '刷新资产': '자산 새로고침',
    '充值': '입금',
    '资金账户': '자금 계정',
    '燃料账户': '연료 계정',
    '点卡账户': '포인트 계정',
    '充值提现订单': '입출금 주문',
    '资金流水': '자금 내역',
    '充值订单': '입금 주문',
    '提现订单': '출금 주문',
    '全部状态': '전체 상태',
    '渠道 · 地址': '네트워크 · 주소',
    '审核中': '검토 중',
    '暂无订单数据': '주문 데이터 없음',
    '账单明细': '청구 상세',
    '导出当月账单': '월간 청구서 내보내기',
    '本月服务费 (USDT)': '이번 달 서비스 수수료 (USDT)',
    '本月结算收益 (USDT)': '이번 달 정산 수익 (USDT)',
    '可用点卡': '사용 가능 포인트',
    '逐笔可查': '건별 조회',
    '燃料 / 点卡记录': '연료 / 포인트 기록',
    '充值 / 提现记录': '입출금 기록',
    '购买点卡 / 资金划转记录': '포인트 구매 / 자금 이체 기록',
    '燃料 / 点卡': '연료 / 포인트',
    '充值 / 提现': '입금 / 출금',
    '购买点卡/资金划转': '포인트 구매 / 자금 이체',
    '类别查询': '유형 조회',
    '购买点卡与燃料划转记录类型': '포인트 구매 및 연료 이체 기록 유형',
    '购买点卡记录': '포인트 구매 기록',
    '燃料划转记录': '연료 이체 기록',
    '燃料划转': '연료 이체',
    '记录类型': '기록 유형',
    '支付金额 (USDT)': '결제 금액 (USDT)',
    '资金账户 / 燃料账户': '자금 계정 / 연료 계정',
    '资金账户 → 燃料账户': '자금 계정 → 연료 계정',
    '燃料账户 → 资金账户': '연료 계정 → 자금 계정',
    '搜索策略名称…': '전략 이름 검색…',
    '全部类型': '전체 유형',
    '全部交易': '전체 거래',
    '账单类型': '청구 유형',
    '收益 (USDT)': '수익 (USDT)',
    '余额 (USDT)': '잔액 (USDT)',
    '返回通知中心': '알림 센터로 돌아가기',
    '通知详情': '알림 상세',
    '重新加载': '다시 로드',
    '点击查看通知详情': '알림 상세 보기',
    '我们会向该邮箱发送一封含 6 位验证码的邮件，请注意查收垃圾邮件箱。': '해당 이메일로 6자리 인증 코드를 보내드립니다. 스팸 메일함도 확인해 주세요.',
    '邮箱格式不正确，请检查后重试': '이메일 형식이 올바르지 않습니다. 확인 후 다시 시도해 주세요.',
    '选择收益年份': '수익 연도 선택',
    '选择收益月份': '수익 월 선택',
    '尚未同步': '아직 동기화되지 않음',
    '部分数据暂不可用': '일부 데이터를 일시적으로 사용할 수 없습니다',
    '前往机器人页 ›': '봇 페이지로 이동 ›',
    '查看策略 ›': '전략 보기 ›',
    '查看收益明细': '수익 상세 보기',
    '查看完整榜单 ›': '전체 순위 보기 ›',
    '用于抵扣机器人策略服务费': '봇 전략 서비스 수수료 차감에 사용됩니다',
    '消费记录': '사용 내역',
    '常见问题、费用与分成说明、风控规则与安全指南。': '자주 묻는 질문, 수수료와 수익 배분, 위험 관리 규칙 및 보안 안내입니다.',
    '三步完成首个机器人配置：充值 → 划转燃料 → 选择策略模板。': '입금 → 연료 이체 → 전략 템플릿 선택의 세 단계로 첫 봇 설정을 완료하세요.',
    '高频出手、快进快出': '고빈도 진입과 빠른 청산',
    '顺势单向持仓、回撤可控': '추세 추종 단방향 포지션과 통제 가능한 낙폭',
    '交易所加载中': '거래소 로딩 중',
    '从上方「产品与策略」选择一个模板，三步即可启动你的第一台机器人；': '위의 상품 및 전략에서 템플릿을 선택하면 세 단계로 첫 봇을 시작할 수 있습니다.',
    '风险保护与保证金监控将自动开启。': '위험 보호와 증거금 모니터링이 자동으로 활성화됩니다.',
    '当前状态不可操作': '현재 상태에서는 작업할 수 없습니다',
    '正在加载收益趋势…': '수익 추세 로딩 중…',
    '正在加载榜单…': '순위 로딩 중…',
    '燃料账户、资金账户和点卡账户资产分布': '연료, 자금 및 포인트 계정 자산 분포',
    '资金账户和点卡账户资产分布': '자금 및 포인트 계정 자산 분포',
    '资金与点卡账户集中管理': '자금 및 포인트 계정 통합 관리',
    '用于充值、提现与内部划转。': '입금, 출금 및 내부 이체에 사용됩니다.',
    '用于机器人运行与平台服务结算。': '봇 운영 및 플랫폼 서비스 정산에 사용됩니다.',
    '用于抵扣平台服务费，消费时优先扣除。': '플랫폼 서비스 수수료 차감에 사용되며 사용 시 우선 차감됩니다.',
    '充值与提现订单与账单页资金流水保持一致，可交叉核对。': '입출금 주문은 청구 페이지의 자금 내역과 일치하며 상호 확인할 수 있습니다.',
    '每一笔收益、扣费与账户变化，透明可查': '모든 수익, 차감 및 계정 변동을 투명하게 확인할 수 있습니다',
    '按当前消耗预计可用 --': '현재 사용량 기준 예상 이용 기간 --',
    '正在同步账单记录…': '청구 기록 동기화 중…',
    '暂无符合条件的账单记录': '조건에 맞는 청구 기록이 없습니다',
    '充值提现记录类型': '입출금 기록 유형',
    '订单类型': '주문 유형',
    '交易类型': '거래 유형',
    '利润分成': '수익 배분',
    '点卡抵扣': '포인트 차감',
    '正在读取通知详情…': '알림 상세 로딩 중…',
    '左右滑动查看': '좌우로 밀어 보기',
    '暂无收益数据': '수익 데이터 없음',
    '平均健康度': '평균 건강도',
    '币币策略最小仓位读取失败': '현물 전략의 최소 포지션을 불러오지 못했습니다',
    '未找到当前币币策略的交易对配置': '현재 현물 전략의 거래 페어 설정을 찾을 수 없습니다',
    '机器人页面尚未加载当前交易所状态': '봇 페이지에서 현재 거래소 상태를 아직 불러오지 못했습니다',
    '请输入有效的杠杆倍数': '유효한 레버리지를 입력해 주세요',
    '我已了解暂停策略可能影响当前挂单与持仓': '전략 일시정지가 기존 주문과 포지션에 영향을 줄 수 있음을 확인했습니다',
    '请先确认已了解暂停策略的风险': '전략 일시정지 위험을 확인해 주세요',
    'FITFI 投入金额不能超过 2000 USDT': 'FITFI 투자 금액은 2,000 USDT를 초과할 수 없습니다',
    '只授权交易，不授权提币': '거래 권한만 허용하며 출금 권한은 허용하지 않습니다',
    '绑定时请勿开启提币权限；建议同时配置 IP 白名单以提升安全性。': '연결할 때 출금 권한을 활성화하지 마세요. 보안을 위해 IP 허용 목록을 설정하세요.',
    '登录保护': '로그인 보호',
    '台运行中': '대 실행 중',
    '条策略': '개 전략',
    'AI智能化策略': 'AI 자동화 전략',
    '100 USDT 开启，AI 智能选指标并自动运行': '100 USDT로 시작하며 AI가 지표를 선택해 자동 실행합니다',
    '比普通版收益高，覆盖范围适中': '일반 버전보다 수익이 높고 대응 범위가 적절합니다',
    '收益最高的版本，下跌覆盖 30% 左右，适合主流币': '수익이 가장 높은 버전으로 약 30% 하락 구간을 대응하며 주요 코인에 적합합니다',
    '请先删除当前仓位后再修改策略': '현재 포지션을 삭제한 후 전략을 수정해 주세요',
    '内部转账失败': '내부 이체에 실패했습니다',
    '，请手动启动机器人': '; 봇을 수동으로 시작해 주세요',
    '修改后的投入金额低于当前投入金额，确认继续修改吗？': '수정할 투자 금액이 현재 금액보다 낮습니다. 계속하시겠습니까?',
    'AI 网格': 'AI 그리드',
    '首推': '추천',
    '全自动 AI 交易，适合所有行情': '모든 시장 상황에 적합한 완전 자동 AI 거래',
    '启动 UPlus-S1': 'UPlus-S1 시작',
    '请输入投入金额': '투자 금액을 입력해 주세요',
    '可用余额': '사용 가능 잔액',
    '最低 1,000 USDT，最高 20,000 USDT': '최소 1,000 USDT, 최대 20,000 USDT',
    '固定杠杆': '고정 레버리지',
    '固定使用 10x 杠杆': '고정 10배 레버리지를 사용합니다',
    '策略参数由 Orbit 自动管理，创建后将根据行情独立运行。': '전략 매개변수는 Orbit이 자동 관리하며 생성 후 시장 상황에 따라 독립적으로 실행됩니다.',
    '确认启动': '시작 확인',
    '可用余额读取失败': '사용 가능 잔액을 불러오지 못했습니다',
    '请输入有效的投入金额': '유효한 투자 금액을 입력해 주세요',
    'Orbit 策略投入金额不能低于 1,000 USDT': 'Orbit 투자 금액은 1,000 USDT 이상이어야 합니다',
    'Orbit 策略投入金额不能超过 20,000 USDT': 'Orbit 투자 금액은 20,000 USDT를 초과할 수 없습니다',
    '请先成功读取交易所可用余额': '거래소 사용 가능 잔액을 먼저 불러와 주세요',
    'UPlus-S1合约交易风险提示': 'UPlus-S1 계약 거래 위험 안내',
    'Orbit 策略创建失败': 'Orbit 전략 생성 실패',
    'Orbit 策略创建失败，请稍后重试': 'Orbit 전략 생성에 실패했습니다. 잠시 후 다시 시도해 주세요',
    'UPlus-S1 创建成功': 'UPlus-S1 생성 완료',
    '确认减少投入金额': '투자 금액 감소 확인'
  }
}
